"use client";

import React from "react";
import styles from "./connect-wallet-btn.module.scss";
import { ConnectButton } from "@rainbow-me/rainbowkit";
import Image from "next/image";
import classNames from "classnames";
import { PiPlugs } from "react-icons/pi";
import { MdElectricBolt } from "react-icons/md";
import { useMainnetToTestnetSwitchStore } from "@/stores/mainet-testnet-switcher.store";
import LoadingIcon from "@/components/layout/loading-icon";

export const ConnectWalletBtn = () => {
  const isSwitching = useMainnetToTestnetSwitchStore(
    (store) => store.isSwitching,
  );

  return (
    <ConnectButton.Custom>
      {({
        account,
        chain,
        openAccountModal,
        openChainModal,
        openConnectModal,
        authenticationStatus,
        mounted,
      }) => {
        // Note: If your app doesn't use authentication, you
        // can remove all 'authenticationStatus' checks
        return (
          <div>
            {(() => {
              if (isSwitching) {
                return (
                  <div className={styles.connectWalletBtn}>
                    <button
                      className={styles.chain}
                      style={{ alignItems: "center", justifyContent: "center" }}
                      onClick={openChainModal}
                    >
                      <LoadingIcon size={20} />
                    </button>
                    <button
                      onClick={(e) => {
                        e.stopPropagation();
                        openAccountModal();
                      }}
                      type="button"
                      className={classNames(styles.connected)}
                    >
                      <MdElectricBolt size={17} />
                    </button>
                    <div className={styles.walletAddress}></div>
                  </div>
                );
              }
              if (!chain) {
                return (
                  <div className={styles.connectWalletBtn}>
                    <button className={styles.chain} onClick={openConnectModal}>
                      Connect wallet
                    </button>
                    <button
                      onClick={(e) => {
                        e.stopPropagation();
                        openConnectModal();
                      }}
                      type="button"
                      className={classNames(styles.connected)}
                    >
                      <PiPlugs size={24} />
                    </button>
                  </div>
                );
              }
              if (chain.unsupported && !isSwitching) {
                return (
                  <button
                    onClick={openChainModal}
                    type="button"
                    className={classNames(
                      styles.connectWalletBtn,
                      styles.wrongNetwork,
                    )}
                  >
                    Network unaccepted
                  </button>
                );
              }
              return (
                <div
                  style={{ display: "flex", alignItems: "center" }}
                  className={styles.connectWalletBtn}
                >
                  <button className={styles.chain} onClick={openChainModal}>
                    {chain.hasIcon && (
                      <>
                        {chain.iconUrl && (
                          <Image
                            alt={chain.name ?? "Chain icon"}
                            src={chain.iconUrl}
                            width={20}
                            height={20}
                          />
                        )}
                      </>
                    )}
                    <div className={classNames(styles.chainName)}>
                      <span>{chain.name}</span>
                      <span className={styles.walletAddress}>
                        {account?.displayName} {account?.displayBalance}
                      </span>
                    </div>
                  </button>
                  <button
                    onClick={(e) => {
                      e.stopPropagation();
                      openAccountModal();
                    }}
                    type="button"
                    className={classNames(styles.connected)}
                  >
                    <MdElectricBolt size={17} />
                  </button>
                  <div className={styles.walletAddress}></div>
                </div>
              );
            })()}
          </div>
        );
      }}
    </ConnectButton.Custom>
  );
};

export default ConnectWalletBtn;
